import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Select } from './ui.tsx';

/** Lista de escolhas (sem repetir), no padrão das subfamílias de atuação do cargo. */
export function IdList({
  label,
  hint,
  error,
  disabled,
  addLabel,
  value,
  onChange,
  items,
  className,
}: {
  label: string;
  hint?: string;
  error?: string;
  disabled?: boolean;
  addLabel: string;
  value: string[];
  onChange: (v: string[]) => void;
  items: { id: string; label: string }[];
  className?: string;
}) {
  const { t } = useTranslation();
  const [adding, setAdding] = useState('');
  const labelOf = (id: string) => items.find((i) => i.id === id)?.label ?? id;
  const free = items.filter((i) => !value.includes(i.id));
  return (
    <div className={`flex flex-col gap-2 ${className ?? ''}`}>
      <span className="text-sm font-medium">{label}</span>
      {hint && <span className="text-xs text-muted">{hint}</span>}
      {value.length > 0 && (
        <ul className="flex flex-wrap gap-2">
          {value.map((id) => (
            <li
              key={id}
              className="flex items-center gap-2 rounded-md border border-rule px-2 py-1 text-sm"
            >
              {labelOf(id)}
              <button
                type="button"
                className="text-xs text-muted hover:text-danger"
                aria-label={`${t('people.movement.remove')}: ${labelOf(id)}`}
                onClick={() => onChange(value.filter((x) => x !== id))}
              >
                {t('people.movement.remove')}
              </button>
            </li>
          ))}
        </ul>
      )}
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-[1fr_auto]">
        <Select
          disabled={disabled || free.length === 0}
          value={adding}
          onChange={(ev) => setAdding(ev.target.value)}
        >
          <option value="">{t('common.choose')}</option>
          {free.map((i) => (
            <option key={i.id} value={i.id}>
              {i.label}
            </option>
          ))}
        </Select>
        <Button
          variant="secondary"
          disabled={disabled || !adding}
          onClick={() => {
            onChange([...value, adding]);
            setAdding('');
          }}
        >
          {addLabel}
        </Button>
      </div>
      {error && <span className="text-xs text-danger">{error}</span>}
    </div>
  );
}
